export const getTeacherValue = (values: any) => {
    return Number(JSON.parse(values || '{}')?.teacherValue || '');
};
